import DOMPurify from 'dompurify'

/**
 * 게시글 본문 HTML 을 그리기 전에 거른다. 서버 저장 sanitize(jsoup Safelist, moms-be BoardContentSanitizer)와 같은 허용 목록이다 —
 * 1.0 이 쓴 글은 서버 sanitize 를 거치지 않고 저장돼 있어 화면에서 반드시 거른다(LOGISPRD-15070).
 * `img` 는 그리지 않는다 — 1.0 본문 이미지는 상세 응답 첨부 목록(files)에 함께 나온다.
 */
const ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'u', 's', 'ol', 'ul', 'li', 'a', 'span']
const ALLOWED_ATTR = ['href', 'class', 'style', 'target', 'rel']
const ALLOWED_CLASS = /^ql-(align|indent)-[a-z0-9-]+$/
const ALLOWED_STYLE = new Set(['color', 'background-color'])

const purifier = DOMPurify()

purifier.addHook('uponSanitizeAttribute', (node, data) => {
  if (data.attrName === 'class') {
    const kept = data.attrValue.split(/\s+/).filter((c) => ALLOWED_CLASS.test(c))
    data.attrValue = kept.join(' ')
    data.keepAttr = kept.length > 0
  }
  if (data.attrName === 'style') {
    const kept = data.attrValue
      .split(';')
      .map((d) => d.trim())
      .filter((d) => ALLOWED_STYLE.has(d.split(':')[0]?.trim().toLowerCase()) && !/url\s*\(|expression\s*\(/i.test(d))
    data.attrValue = kept.join('; ')
    data.keepAttr = kept.length > 0
  }
})

purifier.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

export const sanitizeBoardHtml = (html: string | null | undefined): string =>
  purifier.sanitize(html ?? '', {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP: /^https?:\/\//i,
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  })
